import { render, staticRenderFns } from "./GroupDescription.vue?vue&type=template&id=5a529246&scoped=true&"
import script from "./GroupDescription.vue?vue&type=script&lang=ts&"
export * from "./GroupDescription.vue?vue&type=script&lang=ts&"
import style0 from "./GroupDescription.vue?vue&type=style&index=0&id=5a529246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a529246",
  null
  
)

export default component.exports